import request from '@/utils/request'
//import request from '@/utils/requestVueSrouce'
//import {request} from '@/api/loginService.js'

export function getUserDeptListApi() {
  return request({
    url: '/session/getUserDeptList',
    method: 'post',
    params:{}
  })
}

export function getUserListApi(query) {
  return request({
    url: '/session/getUserList',
    method: 'post',
    data:query
  })
}

export function loginByUsername(query) {
  // const data = {
  //   username,
  //   password
  // } 
  return request({
    url: '/session/loginActionV1',
    method: 'post',
    data:query
  })
}

export function logout() {
  return request({
    url: '/session/loginOutAction',
    method: 'post'
  })
}

export function getUserInfo(token) {
  return request({
    url: '/user/info',
    method: 'get',
    params: { token }
  })
}

export function checkLoginAction(token) {
  return request({
    url: '/session/checkLoginAction',
    method: 'post',
    data: { token }
  })
}

export function getToken(parms) {
  return request({
    url: '/session/getToken',
    method: 'post',
    data: parms
  })
}

export function vierfiyCode(parms) {
  return request({
    url: '/session/verifyCode',
    method: 'post',
    responseType: 'blob',
    data: parms
  })
}




// WEBPACK FOOTER //
// ./src/api/login.js